<script lang="ts" setup>
import { BRAND_VIEWED } from "~~/config/algolia-insights"
import { algoliaSearch } from "~~/config/algolia"
import { viewProductDetail } from "~/utils/algolia"
import { SeoBaseProps } from "~/components/seo/Base.props"
import { customPaths } from "~/utils/constants"
import consola from "consola"

const route = useRoute()
const { locale } = useI18n()

const requestId = route.path + "_" + Date.now()

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Brand page rendering start",
    route.path,
    requestId
  )

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Brand page Gluon start",
    route.path,
    requestId
  )

const { data, error } = await usePage(
  `/api/gluon/fetchProductBrandPage/${locale.value}/${
    route.params.brand as string
  }/product_brand.js`
)

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Brand page Gluon end",
    route.path,
    requestId
  )

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Brand page promotions start",
    route.path,
    requestId
  )

const { data: hasActivePromotions } = await useFetch(
  "/api/getActivePromotionsBrand",
  {
    query: { limitQuery: 1, brand: route.params.brand as string }
  }
)

import.meta.server &&
  consola.info(
    new Date().toISOString(),
    "Brand page promotions end",
    route.path,
    requestId
  )

if (error.value) {
  if (useRuntimeConfig().seo?.redirectMissingBrandToBrandHome) {
    await navigateTo(customPaths.brands, {
      redirectCode: 302
    })
  } else {
    import.meta.server &&
      consola.error(
        new Date().toISOString(),
        "Brand page error",
        "Error loading Gluon data",
        route.path,
        requestId,
        error.value
      )
    throw createError({
      message: error.value.message,
      statusCode: error.value.statusCode ?? 404
    })
  }
}

const loadPage = ref(
  isNaN(parseInt(route.params.page as string))
    ? 0
    : parseInt(route.params.page as string) - 1
)

// Prevents scrolling when filters change
useBlockScrollOnFilters()

onMounted(async () => {
  const algolia = await algoliaSearch()
  viewProductDetail(algolia.indices.brands, `${BRAND_VIEWED}`, [
    `${data?.value?.id}`
  ])
})

const seoData = computed((): SeoBaseProps => {
  return {
    ...data.value?.seo,
    metaTitle:
      `${data.value?.seo.metaTitle} - Pagina ${route.params.page}` ?? undefined,
    metaDescription:
      `${data.value?.seo.metaDescription} - Pagina ${route.params.page}` ??
      undefined
  }
})
</script>

<template>
  <div v-if="data">
    <SeoBase v-bind="seoData" />
    <PagesBrandDetail
      v-bind="data"
      :load-page="loadPage"
      :hasActivePromotions="hasActivePromotions ?? false"
    />
  </div>
</template>
